import { alertService } from "Apis";
import {
  ApiAlertPayload,
  ApiAlertResponse,
  ApiChartPayload,
  ApiChartResponse,
  ApiChartTemplate,
  ApiChartType,
} from "@incendium/api";
import { isEmpty } from "Helpers/isEmpty";
import {
  parseChartFromResponse,
  parseIChartToChartPayload,
} from "features/chartLibrary/utils";

const alertNoticationChart = (
  chart: ApiChartResponse,
  alert: ApiAlertResponse,
  projectId: number,
): ApiChartPayload => {
  chart = parseIChartToChartPayload(parseChartFromResponse(chart));
  chart.name = `${alert.name} - Additional Metrics`;
  chart.type = ApiChartType.TABLE;
  chart.template = ApiChartTemplate.TABLE;
  chart.projectId = projectId;
  return chart;
};

const alertToPayload = (
  alert: ApiAlertResponse,
  projectId: number,
): ApiAlertPayload => {
  return {
    ...alert,
    requirements: alert.requirements?.map((r) => ({
      ...r,
      chart: r.chart
        ? parseIChartToChartPayload(parseChartFromResponse(r.chart))
        : undefined,
      conditionGroups: r.conditionGroups?.map((cg) => ({
        ...cg,
        conditions: cg.conditions?.filter((c) => !isEmpty(c)),
      })),
    })),
    chartNotifications: alert.chartNotifications?.map((cn) => ({
      ...cn,
      chartLastNDays: cn.chartLastNDays ?? 30,
      chart: alertNoticationChart(cn.chart ?? {}, alert, projectId),
    })),
  };
};

export const saveAlert = async (projectId: number, alert: ApiAlertResponse) => {
  const fn = alert.id
    ? alertService.alertServiceUpdateAlert({
        projectId,
        alertId: alert.id as number,
        payload: alertToPayload(alert, projectId),
      })
    : alertService.alertServiceCreateAlert({
        projectId,
        payload: alertToPayload(alert, projectId),
      });
  const res = await fn;
  return res;
};
